import inputRuleHandler from "@ext/markdown/elements/list/edit/logic/inputRuleHandler";
import listContinuationPlugin from "@ext/markdown/elements/list/edit/logic/listContinuation";
import toggleListPrepare from "@ext/markdown/elements/list/edit/logic/toggleListPrepare";
import startInDomain from "@ext/markdown/elements/list/edit/models/orderList/logic/startInDomain";
import listCounterReset from "@ext/markdown/elements/list/render/listCounterReset";
import { InputRule, mergeAttributes } from "@tiptap/core";
import { OrderedList } from "@tiptap/extension-list";

const CustomOrderList = OrderedList.extend({
	renderHTML(props) {
		// Домен держится и на атрибуте `start`, а не только на счетчике: чтение приводит в домен оба
		// (`OrderList.tsx`, `HTMLLists.tsx`), и разметка редактора не должна от нее отличаться. Номер
		// отдается родителю уже в домене, поэтому единицу он по-прежнему не пишет.
		const start = startInDomain(props.HTMLAttributes.start);
		const counterReset = listCounterReset(start);
		const [tag, attrs, hole] = this.parent({ ...props, HTMLAttributes: { ...props.HTMLAttributes, start } }) as [
			string,
			Record<string, unknown>,
			0,
		];
		return [tag, counterReset ? mergeAttributes(attrs, { style: `counter-reset: ${counterReset}` }) : attrs, hole];
	},

	addAttributes() {
		return {
			...this.parent?.(),
			start: {
				default: 1,
				parseHTML: (element: HTMLElement) =>
					startInDomain(element.hasAttribute("start") ? element.getAttribute("start") : 1),
			},
		};
	},

	addInputRules() {
		const inputRule = this.parent()[0];
		return [inputRuleHandler(new InputRule({ find: /^(\d{1,9})\.\s$/, handler: inputRule.handler }))];
	},

	addCommands() {
		return {
			toggleOrderedList:
				() =>
				({ editor, chain }) => {
					toggleListPrepare(editor, chain());
					return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).run();
				},
		};
	},

	addProseMirrorPlugins() {
		return [...(this.parent?.() ?? []), listContinuationPlugin()];
	},
});

export default CustomOrderList;
